import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0f00] py-12 px-4" data-id="element-332">
      <div className="max-w-5xl mx-auto" data-id="element-333">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-334">
          <div data-id="element-335">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-336">
              +300
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-337">
              entrenadores confían
            </div>
          </div>
          <div data-id="element-338">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-339">
              6+6
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-340">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-341">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-342">
              4.9/5
            </div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-343">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-344">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-345">🇦🇷</div>
            <div className="text-[#F97316] text-sm font-semibold mt-1" data-id="element-346">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-347">
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-348">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-349">
              MR
            </div>
            <div data-id="element-350">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-351">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-352">
                "Organicé todo el año en una tarde. Ahora tengo cada
                entrenamiento pensado y secuenciado para todos mis grupos."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-353">
                — Marcelo R., Buenos Aires | Entrenador de Club de Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-354">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-355">
              JG
            </div>
            <div data-id="element-356">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-357">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-358">
                "Las sesiones con progresión real por categoría cambiaron todo.
                Mis jugadores de U15 mejoraron más en 2 meses que en todo el año
                anterior."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-359">
                — Jorge G., Rosario | DT en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#F97316]/20 rounded-xl p-4" data-id="element-360">
            <div className="w-10 h-10 rounded-full bg-[#F97316]/20 flex items-center justify-center text-[#F97316] font-black text-sm flex-shrink-0" data-id="element-361">
              SV
            </div>
            <div data-id="element-362">
              <div className="text-[#F97316] text-xs mb-1" data-id="element-363">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-364">
                "Adapto el mismo drill a 3 categorías distintas en 5 minutos.
                Antes me llevaba horas inventar qué hacer."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-365">
                — Sofía V., Córdoba | Profesora de Educación Física
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}